import { ConcreteEncodable } from "./ConcreteEncodable";

import { CalculateMarkupRequestImplEncoder } from "../../encoder/CalculateMarkupRequestImplEncoder";

import * as CubiqTS from "../../index";
import { CalculateMarkupRequest } from "../CalculateMarkupRequest";

export class CalculateMarkupRequestImpl
  extends ConcreteEncodable
  implements CalculateMarkupRequest
{
  public static enType: string = "com.bcdfx.model.event.CalculateMarkupRequestImpl";

  /*FID=1*/
  public accountCd: string;
  /*FID=2*/
  public ccy1: string;
  /*FID=3*/
  public ccy2: string;
  /*FID=4*/
  public fixedCcy: string;
  /*FID=5*/
  public clientBuysFixed: boolean;
  /*FID=6*/
  public orderType: CubiqTS.OrderType;
  /*FID=7*/
  public product: CubiqTS.Product;
  /*FID=8*/
  public tenor: CubiqTS.Tenor;
  /*FID=9*/
  public valueDate: CubiqTS.moment.Moment | null = null;
  /*FID=11*/
  public benchmarkCd: string;
  /*FID=12*/
  public requestRate: CubiqTS.BigNumber | null = null;
  /*FID=13*/
  public amount: CubiqTS.BigNumber | null = null;
  /*FID=14*/
  public clientCd: string;
  /*FID=15*/
  public benchmarkDts: CubiqTS.moment.Moment | null = null;
  /*FID=16*/
  public tradingChannel: string;
  /*FID=17*/
  public algoStrategyName: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CalculateMarkupRequestImplEncoder.Instance;
    this.setEncodableType(CalculateMarkupRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "CalculateMarkupRequestImpl[" +
      "accountCd=" +
      this.accountCd +
      "ccy1=" +
      this.ccy1 +
      "ccy2=" +
      this.ccy2 +
      "fixedCcy=" +
      this.fixedCcy +
      "clientBuysFixed=" +
      this.clientBuysFixed +
      "orderType=" +
      this.orderType +
      "product=" +
      this.product +
      "tenor=" +
      this.tenor +
      "valueDate=" +
      this.valueDate +
      "benchmarkCd=" +
      this.benchmarkCd +
      "requestRate=" +
      this.requestRate +
      "amount=" +
      this.amount +
      "clientCd=" +
      this.clientCd +
      "benchmarkDts=" +
      this.benchmarkDts +
      "tradingChannel=" +
      this.tradingChannel +
      "algoStrategyName=" +
      this.algoStrategyName +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
